<template>

    <main class="home">

        <home-header v-if="'homepage_slider_repeater' in page['acf']" :home-header-params="page['acf']['homepage_slider_repeater']"></home-header>

        <tabbed-teaser v-if="showTabbedTeaser" :teaser-filter-params="teaserFilterParams" :categories-data="categoriesData" :all-posts-data="allPostsData" ></tabbed-teaser>

    </main>

</template>

<script>

    // console.log('Home');

    import HomeHeader from './HomeHeader.vue';
    import TabbedTeaser from './TabbedTeaser.vue';

    export default {
        created(){
            // loader.dequeueUpdateTimeoutInMs = 500;
            // this.$root.events.$on('loaded', (id)=>{
            //     this.$set(this.childrenLoaded, id, true);
            // });
            this.load();
        },
        destroyed(){
        },
        mounted(){
			console.log('categoriesData:', this.categoriesData);
        },
        components : {
            HomeHeader,
            TabbedTeaser
        },
        props : {
            'pageData': {
                default: null,
                type: Object,
            },
            'teaserFilterParams' : {
                default : {},
                type : Object,
            },
            'categoriesData': {
                default: () => [],
                type: Array,
            },
            'allPostsData': {
                default: () => [],
                type: Array,
            }
        },
        data(){
            return {
                // childrenLoaded : {},
                page : {
                  acf : {},
                },
                showTabbedTeaser: false
            };
        },
        metaInfo(){
            return {
                meta : [
                    {
                        vmid : 'description',
                        name : 'description',
                        content : this.page['acf']['meta_description'],
                    },
                    {
                        vmid : 'og:description',
                        property : 'og:description',
                        content : this.page['acf']['meta_og_description'],
                    },
                    {
                        vmid : 'og:image',
                        property : 'og:image',
                        content : this.page['acf']['meta_og_image_1200_630'],
                    },
                    {
                        vmid : 'og:image:alt',
                        property : 'og:image:alt',
                        content : this.page['acf']['meta_og_image_alt_text'],
                    },
                    {
                        vmid : 'og:title',
                        property : 'og:title',
                        content : this.page['acf']['meta_og_title'],
                    },
                ],
            };
        },
        methods : {
            load(){
                // Check if page data was passed via props from PHP
                if (this.pageData && Object.keys(this.pageData).length > 0) {
                    console.log('Home.vue: Loading from PHP pageData prop');
                    console.log('categoriesData:', this.categoriesData);
                    console.log('allPostsData:', this.allPostsData);
                    this.page = this.pageData;
                    this.showTabbedTeaser = true;
                    return;
                }

                // Otherwise load from API (SPA mode)
                if (!this.$root.promises || !this.$root.promises.home) {
                    console.error('Home.vue: No pageData prop and $root.promises.home not available');
                    return;
                }

                this.$root.promises.home
                    .then( response => {
                        this.page = response.data;
                        this.showTabbedTeaser = true;
                        this.teaserFilterParams['categories_exclude'] = 1;
                    })
                    .catch( error => {
                        console.log('error', error);
                    });

                window.setTimeout(()=>{
                    try {
                        // this.$ga.page(this.$route.fullPath);
                        if (window.dataLayer) {
                            window.dataLayer.push({
                                event: 'Pageview',
                                url: this.$route.path.toLowerCase().replace(/\/$/, "")
                            });
                            window.dataLayer.push({
                                event: 'scrolldepth',
                                url: this.$route.path.toLowerCase().replace(/\/$/, "")
                            });
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
        },
    }

</script>
